import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m0 0v3.176h2.6464v-2.1193l-1.0563-1.0568zm0.26355 0.26355h1.0594v1.0594h1.0578v1.587h-2.1172zm1.324 0.10697 0.68626 0.68781h-0.68626z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "10",
    height: "12",
    version: "1.1",
    viewBox: "0 0 2.6458 3.175",
    xmlns: "http://www.w3.org/2000/svg",
    fill: _ctx.color
  }, _hoisted_3, 8, _hoisted_1))
}